import * as z from "zod/v4";
import {
  aeoOverrideType,
  competitorOverride,
} from "./competitor-override-types";

export const createCompetitorOverride = {
  name: "createCompetitorOverride" as const,
  input: z.object({
    matchTerm: z.string().min(1),
    overrideType: z.enum(aeoOverrideType),
    canonicalName: z.string().optional(),
  }),
  output: competitorOverride,
};
